import React from 'react';
import PropTypes from 'prop-types';
import TouchMenuItem from '../desktop-menu-item/TouchMenuItem';
import DesktopMenuItem from '../desktop-menu-item/DesktopMenuItem';
import FlyoutMenu from '../flyout-menu/FlyoutMenu';
import styles from './DesktopMenu.scss';
import { isTouchDevice } from '../../../utils/device/identifyDevice';

const DesktopMenu = ({ child }) => {
  const filteredChild = child?.filter(
    item => item.isDisplayedInGlobalNav !== false
  );

  const MenuItem =
    typeof window !== 'undefined' && isTouchDevice()
      ? TouchMenuItem
      : DesktopMenuItem;

  return (
    <nav className={styles.desktopMenu} data-testid="navigation-menu">
      <ul className={styles.desktopMenuList}>
        {filteredChild.map(item => {
          const { id, name, url, child: childItems } = item;
          return (
            <MenuItem key={name} label={name} url={url}>
              {childItems?.length > 0 && (
                <FlyoutMenu id={id} columns={childItems} hierarchy={name} />
              )}
            </MenuItem>
          );
        })}
        <div className={styles.desktopMenuOverlay} />
      </ul>
    </nav>
  );
};

const itemShape = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  url: PropTypes.string,
};
itemShape.child = PropTypes.arrayOf(PropTypes.shape(itemShape));

DesktopMenu.propTypes = {
  child: PropTypes.arrayOf(PropTypes.shape(itemShape)).isRequired,
};

export default DesktopMenu;
